import {
  fetchCustomers,
  fetchCustomer,
  deleteCustomer,
  fetchCustomerProfile,
  downloadCustomerCsv,
  updateCustomer,
  updateCustomerProfile,
  getPassword,
  createCustomer
} from '../services/napi';
import {
  CUSTOMERS_FETCH_SUCCESS,
  DOWNLOAD_CUSTOMERS_SUCCESS,
  SET_CUSTOMERS_DRAFT,
  CUSTOMER_FETCH_SUCCESS,
  CUSTOMER_PROFILE_FETCH_SUCCESS,
  CUSTOMER_SET_DRAFT,
  CUSTOMER_PROFILE_SET_DRAFT,
  CUSTOMER_PROFILE_UPDATE_SUCCESS,
  CUSTOMER_PROFILE_UPDATE_DRAFT,
  CUSTOMER_LOADING,
  GENERATE_USERS_PASSWORD_SUCCESS,
  CREATE_CUSTOMER,
  REMOVE_ITEM_FROM_CUSTOMER_DRAFT
} from '../constant/actionType';

export function fetchAllCustomers() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await fetchCustomers(projectId);
      dispatch({
        data: response.data.users,
        type: CUSTOMERS_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function setCustomersDraft(customersDraft) {
  return async (dispatch) => {
    dispatch({ data: customersDraft, type: SET_CUSTOMERS_DRAFT });
  };
}

export function deleteCustomerAction(customerId, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    await deleteCustomer(projectId, customerId);
    onSuccess?.();
  };
}

export function downloadFileAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadCustomerCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `customers.csv`);
    document.body.appendChild(link);
    link.click();

    dispatch({
      data: response.data,
      type: DOWNLOAD_CUSTOMERS_SUCCESS
    });
  };
}

export function fetchCustomerAction(customerId) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await fetchCustomer(projectId, customerId);
    dispatch({ data: response.data.customer, type: CUSTOMER_FETCH_SUCCESS });
  };
}

export function fetchCustomerProfileAction(profileId) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await fetchCustomerProfile(projectId, profileId);
      dispatch({
        data: response.data.profile,
        type: CUSTOMER_PROFILE_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
      dispatch({
        data: {},
        type: CUSTOMER_PROFILE_FETCH_SUCCESS
      });
    }
  };
}

export function setCustomerDraft(body) {
  return async (dispatch) => {
    try {
      dispatch({
        data: body,
        type: CUSTOMER_SET_DRAFT
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function removeItemFromCustomerDraftAction(body) {
  return async (dispatch) => {
    try {
      dispatch({
        data: body,
        type: REMOVE_ITEM_FROM_CUSTOMER_DRAFT
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function setCustomerProfileDraft(body) {
  return async (dispatch) => {
    try {
      dispatch({
        data: body,
        type: CUSTOMER_PROFILE_SET_DRAFT
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function updateCustomerProfileAction(profileId, body, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await updateCustomerProfile(projectId, profileId, body);
    dispatch({
      data: response.data.profile,
      type: CUSTOMER_PROFILE_UPDATE_DRAFT
    });
    if (onSuccess) {
      onSuccess();
    }
  };
}

export function updateCustomerAction(customerId, body, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await updateCustomer(projectId, customerId, body);
    dispatch({
      data: response.data.profile,
      type: CUSTOMER_PROFILE_UPDATE_SUCCESS
    });

    onSuccess?.();
  };
}

export function createCustomerAction(fullName, email, password) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const username = fullName;
    const data = { email, password, username };
    const response = await createCustomer(projectId, data);
    dispatch({ data: response.data.user, type: CREATE_CUSTOMER });
  };
}

export function cleanupAction() {
  return (dispatch) => {
    dispatch({
      type: CUSTOMER_LOADING
    });
  };
}

export function getGeneratedPassword() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getPassword(projectId);
    dispatch({
      data: response.data.generatedPassword,
      type: GENERATE_USERS_PASSWORD_SUCCESS
    });
  };
}
